import React from 'react';
import './listApps.css';

export default class ListApps extends React.Component {

	_renderApp(app){
		return (<a key={app.id} className="container-list-apps">
					<div className="list-apps-item">
						<img className="img-app" src={app.img} alt={app.descricao} />
						<h4  className="titulo-app">{app.nome}</h4>
						<span className="descricao-app">{app.descricao}</span>
						<a href={app.link} target="_blank" className="btn-download" >Baixe agora</a>
					</div>
				</a>);
	}

	render(){
		return(
			<div className="list-apps">
				<h2 className="titulo">{this.props.select === 'jogo' ? "JOGOS" : "UTILITÁRIOS"}</h2>
				<hr style={{width: "15%"}} />
				<br />
				<div className="list-apps-cont">
					{
						this.props.apps.map( app => this._renderApp(app) )
					}
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/listApps.js